import { z } from 'zod';

export const xmlValueSchema = z
  .object({ _text: z.string() })
  .default({ _text: '***Default***' })
  .transform((value) => value._text);

export type XmlValueSchema = z.infer<typeof xmlValueSchema>;
